import { render, staticRenderFns } from "./popProtocolList.vue?vue&type=template&id=24c01490&"
import script from "./popProtocolList.vue?vue&type=script&lang=js&"
export * from "./popProtocolList.vue?vue&type=script&lang=js&"
import style0 from "./popProtocolList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24c01490')) {
      api.createRecord('24c01490', component.options)
    } else {
      api.reload('24c01490', component.options)
    }
    module.hot.accept("./popProtocolList.vue?vue&type=template&id=24c01490&", function () {
      api.rerender('24c01490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/model/protocol/popProtocolList.vue"
export default component.exports